import { IClassname } from '@/lib/shared/model';

export const OpenDiningRoom = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14686_10744)">
        <path
          d="M0.896484 10.1211L2.21434 16.7104H6.16789C6.4009 16.7104 6.62437 16.8029 6.78913 16.9677C6.9539 17.1324 7.04646 17.3559 7.04646 17.5889V21.1032"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.21419 16.7109L1.7749 21.1038"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.1036 10.1211L19.7857 16.7104H15.8322C15.5992 16.7104 15.3757 16.8029 15.2109 16.9677C15.0462 17.1324 14.9536 17.3559 14.9536 17.5889V21.1032"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7856 16.7109L20.2249 21.1038"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 6.16797V21.1036"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.28955 13.1953H16.7109"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9456 5.31919C16.8723 4.03779 13.8843 2.56052 11.0001 0.896484C8.11585 2.56052 5.12786 4.03779 2.05448 5.31919C1.95894 5.35635 1.8794 5.42575 1.82964 5.51537C1.77988 5.605 1.76303 5.7092 1.78201 5.80994C1.80099 5.91068 1.8546 6.00161 1.93357 6.06698C2.01253 6.13235 2.11187 6.16805 2.21438 6.16789H19.7857C19.8882 6.16805 19.9876 6.13235 20.0665 6.06698C20.1455 6.00161 20.1991 5.91068 20.2181 5.80994C20.2371 5.7092 20.2202 5.605 20.1705 5.51537C20.1207 5.42575 20.0412 5.35635 19.9456 5.31919Z"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14686_10744">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
